import { render } from "./BattlesCreateFooter.vue?vue&type=template&id=24062351&scoped=true"
import script from "./BattlesCreateFooter.vue?vue&type=script&lang=js"
export * from "./BattlesCreateFooter.vue?vue&type=script&lang=js"

import "./BattlesCreateFooter.vue?vue&type=style&index=0&id=24062351&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24062351"]])

export default __exports__